export default __webpack_public_path__ + "static/License-1449b03bdd9d71fd2fd0bec60d9ab952.pdf";